import React, { useState, useContext } from "react";
import { Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { getToken } from "../../../../api/Account";
import { tienePermiso } from "../../../../helpers/permisos";
import { DataContext } from "../../../../context/DataContext";
import { useAviso } from "../../../../components/base";
import { deleteSubcidioAsync, getSubcidiosAsync } from "../../../../api/Nomina";
import AddSubcidio from "../subcidios/AddSubcidio";
import HistorialTab from "./HistorialTab";
import {
  celdaFecha,
  periodo,
  useConfirmacion,
  useEscritura,
  useListaRemota,
} from "../comunes";

const Subsidios = ({ id }) => {
  const [showModal, setShowModal] = useState(false);

  const token = getToken();
  const { access } = useContext(DataContext);
  const aviso = useAviso();
  const escribir = useEscritura();
  const { pedir, dialogo } = useConfirmacion();

  const {
    datos: historySubcidio,
    cargando,
    error,
    reload: localReload,
    setReload: setLocalReload,
  } = useListaRemota(() => getSubcidiosAsync(token, id));

  const deleteSubcidio = async (subcidioId) => {
    const ok = await escribir(
      () => deleteSubcidioAsync(token, subcidioId),
      "No se pudo eliminar el subsidio"
    );
    if (!ok) return;
    setLocalReload(!localReload);
    aviso.exito("Subsidio eliminado");
  };

  const pedirEliminar = (row) =>
    pedir({
      titulo: "Eliminar subsidio",
      mensaje: (
        <>
          <Typography component="p" sx={{ mb: 1 }}>
            {`Se eliminará el subsidio #${row.id}${row.motivo ? ` «${row.motivo}»` : ""} (${periodo(
              row.desde,
              row.hasta
            )}, ${row.dias} ${Number(row.dias) === 1 ? "día" : "días"}).`}
          </Typography>
          <Typography component="p" sx={{ color: "text.secondary" }}>
            Esta acción no se puede deshacer.
          </Typography>
        </>
      ),
      textoConfirmar: "Eliminar subsidio",
      peligro: true,
      onConfirmar: () => deleteSubcidio(row.id),
    });

  // Agregar es el Add... de EmployeesController/NominasController (NOMINA CREAR).
  const puedeAgregar = tienePermiso(access, "NOMINA CREAR");
  const puedeEliminar = tienePermiso(access, "NOMINA DELETE");

  const columnas = [
    {
      id: "id",
      etiqueta: "#",
      desde: "md",
      sx: { fontVariantNumeric: "tabular-nums" },
      render: (row) => row.id,
    },
    {
      id: "motivo",
      etiqueta: "Motivo",
      render: (row) => (
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {row.motivo}
        </Typography>
      ),
    },
    {
      id: "periodo",
      etiqueta: "Período",
      desde: "sm",
      sx: celdaFecha,
      render: (row) => periodo(row.desde, row.hasta),
    },
    {
      id: "dias",
      etiqueta: "Días",
      alinear: "right",
      sx: { textAlign: "right", fontVariantNumeric: "tabular-nums" },
      render: (row) => row.dias,
    },
    {
      id: "restantes",
      etiqueta: "Restantes",
      alinear: "right",
      desde: "md",
      sx: { textAlign: "right", fontVariantNumeric: "tabular-nums" },
      render: (row) => row.diasRestantes,
    },
    {
      id: "riesgo",
      etiqueta: "Riesgo laboral",
      desde: "md",
      render: (row) => (row.isRiesgoLaboral ? "Sí" : "No"),
    },
  ];

  return (
    <div>
      <HistorialTab
        titulo="Subsidios"
        descripcion="Incapacidades de 4 días o más. Hasta 3 días se registra un reposo."
        etiquetaTabla="Historial de subsidios"
        agregar={
          puedeAgregar ? { etiqueta: "Agregar subsidio", onClick: () => setShowModal(true) } : undefined
        }
        cargando={cargando}
        error={error}
        onReintentar={() => setLocalReload(!localReload)}
        etiquetaCarga="Cargando subsidios…"
        filas={historySubcidio}
        columnas={columnas}
        detalleMovil={(row) => (
          <>
            {periodo(row.desde, row.hasta)}
            {row.isRiesgoLaboral ? " · Riesgo laboral" : ""}
          </>
        )}
        etiquetaFila={(row) => `subsidio #${row.id}`}
        vacio={{
          titulo: "Sin subsidios",
          descripcion: "Aquí aparecen los subsidios de 4 días o más del empleado.",
        }}
        acciones={(row) => [
          {
            id: "eliminar",
            etiqueta: "Eliminar",
            icono: <DeleteOutlineIcon />,
            peligro: true,
            visible: row.dias === row.diasRestantes && puedeEliminar,
            onClick: () => pedirEliminar(row),
          },
        ]}
      />

      {showModal ? (
        <AddSubcidio
          id={id}
          setShowModal={setShowModal}
          reload={localReload}
          setReload={setLocalReload}
        />
      ) : null}

      {dialogo}
    </div>
  );
};

export default Subsidios;
